import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import { isTenantRoleLevel, getCurrentOrganizationId } from "../../utils/utils";
var _getEnvConfig = getEnvConfig(),
  HZERO_IMP = _getEnvConfig.HZERO_IMP;
/**
 * 模板头数据查询接口
 * @async
 * @function loadTemplate
 * @param {Object} params - 查询参数
 * @param {String} params.code - 模板编码
 */

export function loadTemplate(_x) {
  return _loadTemplate.apply(this, arguments);
}
function _loadTemplate() {
  _loadTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var prefixPatch, code, tenantId, site, reqUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            prefixPatch = params.prefixPatch, code = params.code, tenantId = params.tenantId;
            site = isTenantRoleLevel();
            reqUrl = prefixPatch ? "".concat(prefixPatch, "/v1/").concat(tenantId, "/import/template/").concat(code, "/info") : "".concat(HZERO_IMP, "/v1/").concat(site ? "".concat(tenantId, "/") : '', "template/").concat(code, "/info").concat(!site ? "?tenantId=".concat(getCurrentOrganizationId()) : '');
            return _context.abrupt("return", request(reqUrl, {
              method: 'GET'
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadTemplate.apply(this, arguments);
}